import { signalRateLimitBackoffFromSeconds } from './rateLimitBackoff';

const STORAGE_RETRY_SEC = 'shefaRateLimitRetryAfterSec';
const STORAGE_RETRY_AT = 'shefaRateLimitStartedAtMs';
const STORAGE_RETURN_TO = 'shefaRateLimitReturnTo';

/**
 * When the API returns 429 with { code: 'RATE_LIMIT' }, send the user to the
 * branded recovery route instead of leaving them on a broken screen.
 * Other 429 responses (e.g. Telegram cooldown) are left unchanged.
 */
export function installFetchRateLimitRedirect() {
  if (typeof window === 'undefined') return;

  const original = window.fetch.bind(window);

  window.fetch = async function patchedFetch(input, init) {
    const response = await original(input, init);
    if (response.status !== 429) return response;
    if (window.location.pathname === '/rate-limited') return response;

    const reqUrl =
      typeof input === 'string'
        ? input
        : input instanceof Request
          ? input.url
          : String(input);

    let isOurApi = false;
    try {
      const resolved = new URL(reqUrl, window.location.origin);
      isOurApi =
        resolved.origin === window.location.origin && resolved.pathname.startsWith('/api');
    } catch {
      isOurApi = typeof reqUrl === 'string' && reqUrl.startsWith('/api');
    }
    if (!isOurApi) return response;

    const ct = response.headers.get('content-type') || '';
    if (!ct.includes('application/json')) return response;

    try {
      const payload = await response.clone().json();
      if (payload && payload.code === 'RATE_LIMIT') {
        const raRaw = response.headers.get('Retry-After');
        const raNum = parseInt(raRaw, 10);
        const retrySec = Number.isFinite(raNum) && raNum > 0 ? raNum : 120;
        try {
          sessionStorage.setItem(STORAGE_RETRY_SEC, String(retrySec));
          sessionStorage.setItem(STORAGE_RETRY_AT, String(Date.now()));
          sessionStorage.setItem(
            STORAGE_RETURN_TO,
            `${window.location.pathname}${window.location.search}${window.location.hash}`
          );
        } catch {
          /* ignore quota / private mode */
        }
        signalRateLimitBackoffFromSeconds(retrySec);
        window.location.assign('/rate-limited');
      }
    } catch {
      /* ignore parse errors */
    }

    return response;
  };
}

export function peekRateLimitReturnPath() {
  if (typeof window === 'undefined') return '/';
  try {
    const v = sessionStorage.getItem(STORAGE_RETURN_TO);
    return v && v.startsWith('/') && !v.startsWith('//') ? v : '/';
  } catch {
    return '/';
  }
}

